// CookieSettings.js
import { useContext, useState, useEffect } from "react";
import { CookieContext } from "./CookieContext";

const CookieSettings = () => {
  const { consent, saveConsent } = useContext(CookieContext);

  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (consent) {
      setAnalytics(consent.analytics);
      setMarketing(consent.marketing);
    }
  }, [consent]);

  const handleSave = () => {
    saveConsent({ analytics, marketing });
    alert("Zapisano ustawienia cookies");
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Ustawienia cookies</h2>

      <div>
        <label>
          <input type="checkbox" checked disabled />
          Cookies niezbędne (zawsze aktywne)
        </label>
      </div>

      <div>
        <label>
          <input
            type="checkbox"
            checked={analytics}
            onChange={(e) => setAnalytics(e.target.checked)}
          />
          Cookies analityczne
        </label>
      </div>

      <div>
        <label>
          <input
            type="checkbox"
            checked={marketing}
            onChange={(e) => setMarketing(e.target.checked)}
          />
          Cookies marketingowe
        </label>
      </div>

      <button onClick={handleSave} style={{ marginTop: "15px" }}>
        Zapisz
      </button>
    </div>
  );
};

export default CookieSettings;
